"use client";
import { queryOptions, useQuery } from "@tanstack/react-query";
import useSession from "@/hooks/QueryHooks/useSession";
import { getSentPendingConnectionRequestsAction } from "../actions";

export const SENT_PENDING_CONNECTION_REQUESTS_QUERY_KEYS = {
  all: ["sent-pending-connection-requests"] as const,
  getSentPendingConnectionRequests: () =>
    [
      ...SENT_PENDING_CONNECTION_REQUESTS_QUERY_KEYS.all,
      "list",
    ] as const,
};

export function getSentPendingConnectionRequestsOptions({
  userId,
  emailVerified,
}: {
  userId: string | undefined;
  emailVerified?: boolean;
}) {
  return queryOptions({
    queryKey:
      SENT_PENDING_CONNECTION_REQUESTS_QUERY_KEYS.getSentPendingConnectionRequests(),
    queryFn: getSentPendingConnectionRequestsAction,
    enabled: !!userId && !!emailVerified,
  });
}

export const useSentPendingConnectionRequests = () => {
  const { data: session } = useSession();
  return useQuery(
    getSentPendingConnectionRequestsOptions({
      userId: session?.id,
      emailVerified: !!session?.emailVerified,
    }),
  );
};
